import { render, staticRenderFns } from "./relevant.vue?vue&type=template&id=8335da44&scoped=true"
import script from "./relevant.vue?vue&type=script&lang=js"
export * from "./relevant.vue?vue&type=script&lang=js"
import style0 from "./relevant.vue?vue&type=style&index=0&id=8335da44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8335da44",
  null
  
)

export default component.exports